import React from 'react';

import { Grid, NothingToSeeHere } from './surveysGrid.sc';

enum ViewMode {
  DEFAULT,
}

interface OwnProps {
  children: JSX.Element[];
  emptyText: string;
}

interface State {
  viewMode: ViewMode;
}

type Props = OwnProps;

class SurveysGrid extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      viewMode: ViewMode.DEFAULT,
    };
  }

  render() {
    if (!this.props.children || this.props.children.length === 0) {
      return <NothingToSeeHere>{this.props.emptyText}</NothingToSeeHere>;
    }

    return (
      <>
        <Grid>{this.props.children}</Grid>
      </>
    );
  }
}

export default SurveysGrid;
